import { Typography } from '@mui/material';
import { Column, useFilters, usePagination, useRowSelect, useSortBy, useTable } from 'react-table';
import { CustomerManagementGridItem } from 'shared/types/customerManagement';
import {
  customerManagementTableColumns,
  hiddenCustomerManagementTableColumns,
} from './columns/customer-management-table-columns';
import { getLocalStoredCustomerFiltersState } from 'customer-management/state/customerFilterState';

const defaultColumn: Partial<Column<CustomerManagementGridItem>> = {
  Filter: () => null,
  Cell: ({ value = '' }) => <Typography variant='body2'>{value}</Typography>,
  disableFilters: true,
  filter: 'equals',
  width: 150,
  minWidth: 150,
  maxWidth: 150,
  align: 'inherit',
};

const getRowId = (row: CustomerManagementGridItem) => row.id;

export function useCustomerManagementTableInstance(data: CustomerManagementGridItem[]) {
  const filterState = getLocalStoredCustomerFiltersState();
  const idIsDeleted = 'isDeleted';
  const idIsMarkedForDeletion = 'isMarkedForDeletion';

  if (filterState.filters) {
    let deletionFilterIndex = filterState.filters?.findIndex(f => f.id === idIsDeleted);
    let deletionFilter = filterState.filters?.find(f => f.id === idIsDeleted);
    if (deletionFilter) {
      if (deletionFilter.value) {
        filterState.filters.splice(deletionFilterIndex, 1);
      }
    } else {
      deletionFilter = { id: idIsDeleted, value: false };
      filterState.filters = [...filterState.filters, deletionFilter];
    }
    let markedForDeletionFilterIndex = filterState.filters?.findIndex(f => f.id === idIsMarkedForDeletion);
    let markedForDeletionFilter = filterState.filters?.find(f => f.id === idIsMarkedForDeletion);
    if (markedForDeletionFilter) {
      filterState.filters.splice(markedForDeletionFilterIndex, 1);
    }
  }

  return useTable<CustomerManagementGridItem>(
    {
      columns: customerManagementTableColumns,
      data,
      initialState: {
        pageSize: 100,
        hiddenColumns: hiddenCustomerManagementTableColumns,
        filters: filterState.filters,
      },
      defaultColumn,
      getRowId,
      autoResetFilters: false,
    },
    useFilters,
    useSortBy,
    usePagination,
    useRowSelect
  );
}
